import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DriverInformation.module.scss'
import { driverLastNameAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const DriverLastName = ({ t, validateDriverLastName, validateMasterNumber, driverLastNameError, driverLastNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const driverLastName = useSelector((state) => state.driver.driverInformation.driverLastName)
  const masterNumber = useSelector((state) => state.driver.driverInformation.masterNumber)

  const handleDriverLastName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(driverLastNameAction(name))
      validateDriverLastName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurDriverLastName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(driverLastNameAction(name))
      validateDriverLastName(driverLastName)
      validateMasterNumber(masterNumber)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        driverLastNameValid === true
          ? driverLastName === ''
            ? ''
            : 'form-group has-success'
          : driverLastNameValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="DriverLastName">
        {t('driver_information.driver_last_name')}
      </label>
      <input
        type="text"
        id="DriverLastName"
        className="form-control"
        value={driverLastName}
        onChange={handleDriverLastName}
        onFocus={() => SetIsFocussed(true)}
        onBlur={onBlurDriverLastName}
        autoComplete="off"
        maxLength="150"
      />
      {driverLastNameValid === true ? (
        driverLastName === '' ? (
          ''
        ) : (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )
      ) : driverLastNameValid === false ? (
        <React.Fragment>
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(driverLastNameError)}</div>
        </React.Fragment>
      ) : (
            ''
          )}
    </div>
  )
}

export default withTranslation('common')(DriverLastName)
